window.acceleratedDataQueue = window.acceleratedDataQueue || [];
window.acceleratedDataQueue.push({
    ACC_Metallbude_Homepage_14: {
        var: {
            gridContainerSelector: '#MainContent > .shopify-section + .custom-section + .shopify-section:has(slider-element.slider--desktop)',
            productGridSelector: '.product-grid .product-card',
            productData: new Map(),
            _flickityInstances: {},
            get rootPath() { return window.Shopify?.routes?.root || '/'; },
            get currency() { return window.Shopify?.currency?.active || 'EUR'; },
            get country() { return window.Shopify?.country || 'DE'; },
            get locale() { return window.Shopify?.locale || 'de'; },
            get storefront_token() {
                try {
                    return JSON.parse(document.getElementById('shopify-features')?.innerHTML || '{}')?.accessToken;
                } catch { return null; }
            },
            collectionHandle: ['bestseller', 'new-in'],
        },
        async fetchCollectionProducts(collectionHandles, first = 20) {
            const token = this.var.storefront_token;
            if (!token) {
                this.error('Storefront token not available');
                return [];
            }

            const handles = [].concat(collectionHandles);
            const { country, locale, currency } = this.var;

            const collectionFields = handles.map(handle => {
                const alias = handle.replace(/[^a-z]/ig, '_');
                return `${alias}: collection(handle: "${handle}") {
                        products(first: $first, sortKey: BEST_SELLING, filters: {available: true}) {
                            edges { 
                                node {
                                    id 
                                    title
                                    handle
                                    images(first: 20) { 
                                        edges { 
                                            node { 
                                            url(transform: {maxWidth: 1200}) 
                                            altText 
                                        } 
                                    } 
                                }
                                featuredImage { url(transform: {maxWidth: 1200}) altText }
                            }
                        }
                    }
                }`;
            }).join('\n');

            const query = `query CollectionProductsBatch($first: Int!) @inContext(country: ${country}, language: ${locale.toUpperCase()}) {
                ${collectionFields}
            }`;

            try {
                const { data } = await this.cache('/api/2025-10/graphql.json', `CollectionProductsBatch-${handles.join('-')}-${first}-${currency}-${locale}-${country}`, true, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': token,
                    },
                    body: JSON.stringify({ query, variables: { first } }),
                });

                if (!data) { this.error('No data in GraphQL response'); return []; }

                return handles.flatMap(handle => {
                    const key = handle.replace(/[^a-z]/ig, '_');
                    const edges = data[key]?.products?.edges || [];
                    return edges.map(({ node }) => {
                        const images = node.images?.edges?.map(e => e.node.url) || [];
                        const featured = node.featuredImage?.url;
                        if (featured && !images.includes(featured)) images.unshift(featured);
                        return { id: node.id, title: node.title, handle: node.handle, images };
                    });
                });
            } catch (err) {
                this.error('GraphQL request failed:', err);
                return [];
            }
        },
        normalizeImageUrl(url) {
            return url?.startsWith('//') ? `https:${url}` : url;
        },
        generateSrcset(url, widths = [180, 360, 540, 720]) {
            return widths.map(w => `${url}?width=${w} ${w}w`).join(', ');
        },
        getProductHandleFromCard(card) {
            const href = card.querySelector('.product-card__media > a.media')?.getAttribute('href') || '';
            return href.match(/\/products\/([^/?#]+)/)?.[1] || null;
        },
        async initProductGalleries(cards, gridContainer) {
            if (!cards.length) return;
            try {
                const products = await this.fetchCollectionProducts(this.var.collectionHandle);
                products.forEach(p => p?.handle && this.var.productData.set(p.handle, p));
                await Promise.all(cards.map((card, i) => this.processProductCard(card).catch(err => this.error(`Error on card ${i + 1}:`, err))));
                this.setupIntersectionObserver(cards, gridContainer);
            } catch (err) {
                this.error('Failed to initialise galleries:', err);
            }
        },
        async processProductCard(card) {
            const processedAttr = 'data-acc-gallery-processed-metallbude-homepage-14';
            if (card.getAttribute(processedAttr) === 'true') return;

            const mediaLink = card.querySelector('.product-card__media > a.media');
            if (!mediaLink) { this.error('Media link not found', card); return; }

            const handle = this.getProductHandleFromCard(card);
            if (!handle) { this.error('Product handle not found in href:', mediaLink.getAttribute('href')); return; }

            const product = this.var.productData.get(handle);
            if (!product) { this.error(`Product "${handle}" not in cache`); return; }
            if ((product.images?.length || 0) <= 1) { this.error(`Product "${handle}" has ≤1 image, skipping`); return; }

            card.setAttribute(processedAttr, 'true');
            this.createProductGallery(mediaLink, product, card);
        },
        createProductGallery(mediaLink, product, card) {
            const ns = this.__testName;
            card.querySelector(`.${ns}-nav-wrapper`)?.remove();
            const existing = mediaLink.querySelector(`.${ns}-carousel`);
            if (existing) { existing.flickity?.destroy(); existing.remove(); }

            const { handle, title, images } = product;
            const slidesHTML = images.map((img, i) => {
                const src = this.normalizeImageUrl(img);
                return `<div class="media media--height w-full h-full overflow-hidden">
                    <img src="${src}?width=821" alt="${title || `Product image ${i + 1}`}"
                         srcset="${this.generateSrcset(src)}" width="821" height="1231"
                         loading="lazy" is="lazy-image">
                </div>`;
            }).join('');

            const bulletsHTML = images.map((_, i) => `<div class="${ns}-bullet">${i + 1}</div>`).join('');

            const secondaryMedia = mediaLink.querySelector('secondary-media');

            (secondaryMedia || mediaLink).insertAdjacentHTML('afterend' /* or beforeend */, `
                <div class="${ns}-carousel product-card__carousel block absolute top-0 left-0 w-full h-full md:block"
                     data-handle="${handle}" data-total-images="${images.length}">
                    ${slidesHTML}
                </div>`);

            if (!secondaryMedia) {
                const carousel = mediaLink.querySelector(`.${ns}-carousel`); // not inserted yet - fix order
            }

            mediaLink.insertAdjacentHTML('afterend', `
                <div class="${ns}-nav-wrapper" data-handle="${handle}" data-total="${images.length}">
                    <div class="${ns}-nav-carousel">${bulletsHTML}</div>
                </div>`);

            const firstSrc = this.normalizeImageUrl(images[0]);
            const mainImg = mediaLink.querySelector('img:not(.flickity-cell img):not(secondary-media img)');
            if (mainImg) {
                mainImg.src = `${firstSrc}?width=821`;
                mainImg.srcset = this.generateSrcset(firstSrc);
                mainImg.loading = 'eager';
            } else {
                mediaLink.insertAdjacentHTML('beforeend', `
                    <img src="${firstSrc}?width=821" alt="${title || 'Product image'}"
                         srcset="${this.generateSrcset(firstSrc)}"
                         width="821" height="1231" loading="eager">`);
            }
        },
        initFlickity(mediaLink, handle) {
            const card = mediaLink.closest('.product-card, .product-card__media') || mediaLink.parentElement;
            if (!card) return;

            const ns = this.__testName;
            const mainSlider = card.querySelector(`.${ns}-carousel[data-handle="${handle}"]`);
            const navWrapper = card.querySelector(`.${ns}-nav-wrapper[data-handle="${handle}"]`);
            const navCarousel = navWrapper?.querySelector(`.${ns}-nav-carousel`);

            if (!mainSlider || !navWrapper || !navCarousel) return;

            this.var._flickityInstances ||= {};
            const existing = this.var._flickityInstances[handle];
            if (existing?.main && existing?.nav) return; // already initialised

            this.runIf(() => typeof window.Flickity === 'function', () => {
                if (existing) {
                    try { existing.main?.destroy(); existing.nav?.destroy(); } catch { }
                }

                const main = new Flickity(mainSlider, {
                    cellSelector: '.media',
                    pageDots: false,
                    prevNextButtons: false,
                    draggable: '>1',
                    accessibility: false,
                    setGallerySize: false,
                    wrapAround: true,
                });

                const nav = new Flickity(navCarousel, {
                    cellSelector: `.${ns}-bullet`,
                    contain: true,
                    cellAlign: 'center',
                    pageDots: false,
                    prevNextButtons: true,
                    draggable: false,
                    freeScroll: true,
                    wrapAround: true,
                });

                const bullets = Array.from(navWrapper.querySelectorAll(`.${ns}-bullet`));
                bullets.forEach((bullet, i) => {
                    bullet.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); main.select(i); });
                });

                navCarousel.querySelector('.flickity-prev-next-button.previous')?.addEventListener('click', () => main.previous(true));
                navCarousel.querySelector('.flickity-prev-next-button.next')?.addEventListener('click', () => main.next(true));

                main.on('change', index => {
                    nav.select(index);
                    bullets.forEach((el, i) => el.classList.toggle('is-active', i === index));
                    requestAnimationFrame(() => main.resize());
                });

                nav.resize();
                nav.select(0);
                bullets[0]?.classList.add('is-active');
                navWrapper.classList.add('is-ready');

                const markReady = () => requestAnimationFrame(() => {
                    main.resize();
                    nav.resize();
                    mainSlider.classList.add('is-ready');
                });

                const imgs = Array.from(mainSlider.querySelectorAll('img'));
                if (!imgs.length) {
                    markReady();
                } else {
                    const toPromise = img => new Promise(resolve => {
                        if (img.complete && img.naturalWidth > 0) return resolve();
                        img.addEventListener('load', resolve, { once: true });
                        img.addEventListener('error', resolve, { once: true });
                    });
                    Promise.race([
                        toPromise(imgs[0]).then(() => Promise.all(imgs.map(toPromise))),
                        new Promise(r => setTimeout(r, 2500)),
                    ]).then(markReady);
                }

                const onResize = this.debounce(() => { main.resize(); nav.resize(); }, 200);
                window.addEventListener('resize', onResize);

                this.var._flickityInstances[handle] = { main, nav, onResize };
            }, 100);
        },

        initCarouselForCard(card) {
            const ns = this.__testName;
            const mediaLink = card.querySelector('.product-card__media > a.media');
            const handle = card.querySelector(`.${ns}-carousel`)?.getAttribute('data-handle');
            if (!mediaLink || !handle) return false;
            if (this.var._flickityInstances[handle]?.main) return false;
            this.initFlickity(mediaLink, handle);
            return true;
        },

        setupIntersectionObserver(cards) {
            const ns = this.__testName;

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    this.initCarouselForCard(entry.target);
                    observer.unobserve(entry.target);
                });
            }, { rootMargin: '50px', threshold: 0.1 });

            cards.forEach(card => {
                if (card.dataset.customProcessed) return;
                card.dataset.customProcessed = 'true';
                if (!card.querySelector(`.${ns}-carousel`)) return;
                observer.observe(card);
            });
        },
        setupSliders() {
            const { gridContainerSelector, productGridSelector } = this.var;
            const cardSelectors = [
                productGridSelector,
                '.product-card',
                '#TabPanel-collection-4+div[id*="TabPanel-collection_"] .product-grid .product-card.product-card--standard',
            ];
            this.runAt(gridContainerSelector, ([gridContainer]) => {
                cardSelectors.forEach(selector => {
                    const fullSelector = `${gridContainerSelector} ${selector}`.replace(/\s+/g, ' ').trim();
                    this.runAt(fullSelector, cards => {
                        this.initProductGalleries(Array.from(cards), gridContainer);
                    }, 300);
                });

                this.setupTabObserver(gridContainer);
            }, 100);
        },
        setupTabObserver(gridContainer) {
            const resizeVisibleSliders = () => {
                Object.values(this.var._flickityInstances).forEach(({ main, nav }) => {
                    if (!main?.element) return;
                    const rect = main.element.getBoundingClientRect();
                    if (rect.width > 0 && rect.height > 0) {
                        requestAnimationFrame(() => { main.resize(); nav?.resize(); });
                    }
                });
            };
            const observer = new MutationObserver(this.debounce((mutations) => {
                const isTabSwitch = mutations.some(m =>
                    m.target !== gridContainer &&
                    !m.target.closest(`.${this.__testName}-carousel`) &&
                    !m.target.closest('.flickity-enabled')
                );
                if (!isTabSwitch) return;
                resizeVisibleSliders();
            }, 150));

            observer.observe(gridContainer, {
                attributes: true,
                subtree: true,
                attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
            });
        },
        init() {
            this.setupSliders();
        },
    },
});